import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client
import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Reply to a question
const GQLAddQuestionandReplies = gql`
  mutation createcity_question_answer(
    $questionId: String
    $userId: String
    $cityName: String
    $message: String
    $postedDate: String
    $updatedDate: String
  ) {
    createcity_question_answer(
      questionId: $questionId
      userId: $userId
      cityName: $cityName
      message: $message
      postedDate: $postedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

// Saving the helpCount to the reply of a question.

const GQLHelpAnswer = gql`
  mutation helpcityanswer(
    $questionId: String
    $answerId: String
    $userId: String
    $cityName: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
  ) {
    helpcityanswer(
      questionId: $questionId
      answerId: $answerId
      userId: $userId
      cityName: $cityName
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

// Add Reply to a question

async function addquestionandreplies(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddQuestionandReplies,
        variables: {
          questionId: adddata.questionId,
          userId: adddata.userId,
          cityName: adddata.cityName,
          message: adddata.message,
          postedDate: adddata.postedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function helpanswer(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpAnswer,
        variables: {
          questionId: adddata.questionId,
          answerId: adddata.answerId,
          userId: adddata.userId,
          helpContent: adddata.helpContent,
          helpStatus: adddata.helpStatus,
          cityName: adddata.cityName,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { addquestionandreplies, helpanswer };
